import { useDispatch } from "react-redux"
import { signOut } from "../../../../../store/authentication/authenticationActions/authenticationActions"
import Button from "../../../../designSystem/Button/Button"
import { useNavigate } from "react-router-dom"

export default () => {

  const dispatch = useDispatch()

  const navigate = useNavigate()

  return (
    <div className="flex-column" style={{ flex: 1 }}>
      <h4>Merci de votre inscription !</h4>
      <p>Votre compte est maintenant en cours de validation. Vous recevrez un email sous peu pour vous informer de la validation de votre compte.</p>
      <Button 
        style={{ alignSelf: 'center' }}
        onClick={() => {
          signOut()(dispatch)
          navigate('/login/acheteurs')
        }}
      >
        Se déconnecter
      </Button>
    </div>
  )
}